import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ProductsConfigService } from '@approot/services/products-config/products-config.service';
import { Utilities } from '@approot/utilities';

import basketJson from './basket-dropdown-options.json';
@Component({
  selector: 'app-basket',
  templateUrl: './basket.component.html',
  styleUrls: ['./basket.component.scss']
})
export class BasketComponent implements OnInit {
  @Input() legForm: FormGroup;
  @Output() basketOpenChanged = new EventEmitter();
  basketDropdownOptions = basketJson;
  cross: string[] = [];
  basketGroup: FormGroup;
  selectedBasketIndex: number = null;
  constructor(private productsConfigService: ProductsConfigService) {}

  ngOnInit(): void {
    this.cross =
      this.productsConfigService.cutOffTimesAndFixingSources.currencyPairInfo.map(
        pairInfo => pairInfo.currencyPair
      );

    this.basketGroup = new FormGroup({
      baskets: new FormArray([])
    });

    this.legForm.get('basket').value.map(basket => {
      (this.basketGroup.get('baskets') as FormArray).push(
        this.makeBasketGroup(basket)
      );
    });
  }

  makeBasketGroup(rowData?: any) {
    const basketRow = Utilities.generateBasket(rowData);

    return basketRow;
  }

  get basketArray() {
    return (this.basketGroup.get('baskets') as FormArray).controls;
  }

  addNewBasket() {
    (this.basketGroup.get('baskets') as FormArray).push(this.makeBasketGroup());
  }

  deleteBasket() {
    (this.basketGroup.get('baskets') as FormArray).removeAt(
      this.selectedBasketIndex
    );
    (this.basketGroup.get('baskets') as FormArray).markAsDirty();
    this.selectedBasketIndex = null;
  }

  saveChanges() {
    if ((this.basketGroup.get('baskets') as FormArray).dirty) {
      (this.legForm.get('basket') as FormArray).clear();
      (this.basketGroup.get('baskets') as FormArray).controls.forEach(
        (basketControl: FormControl, index: number) => {
          const weight = basketControl.get('weight');
          weight.setValidators([Validators.required]);

          weight.setValue(weight.value.replace(/,/g, ''), {
            emitEvent: false
          });

          (this.legForm.get('basket') as FormArray).setControl(
            index,
            basketControl
          );
        }
      );
    }

    /* console.log((this.legForm.get('basket') as FormArray).value);
    console.log(this.legForm.get('basket'));
    console.log((this.legForm.get('basket') as FormArray).value[0].cross);
    console.log((this.legForm.get('basket') as FormArray).valid); */

    this.closeModal();
  }

  closeModal() {
    this.basketOpenChanged.emit(false);
  }
}
